import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { UpdateLocationCallbackType } from 'components/data/WithUrlUpdater';
import { getShowHostelsAlert } from 'modules/sapiSearch/selectors';
import { getNoHostels, isSortAscendingByPrice } from 'modules/search/selectors';
import { Alert } from '@daedalus/atlas/Alert';
import { ButtonLink } from '@daedalus/atlas/ButtonLink';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import OpacityAnimation from '@daedalus/atlas/helpers/OpacityAnimation';
import { Icon } from '@daedalus/atlas/Icon';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
type Props = {
  onChange: UpdateLocationCallbackType;
};
type HostelMessageProps = {
  onClick: (event: React.MouseEvent) => void;
};
type MessageLayoutProps = HostelMessageProps & {
  message: React.ReactNode;
  linkText: React.ReactNode;
};
const HostelsAlertWrapper = /*#__PURE__*/styled('div')({
  name: "HostelsAlertWrapper",
  class: "hl1y1qx",
  propsAsIs: false
});
const ExcludeHostelsMessage = ({
  onClick
}: HostelMessageProps) => {
  return <MessageLayout message={<FormattedMessageWrapper id="resultsIncludeHostels" defaultMessage="Your results include hostel rooms too." />} linkText={<FormattedMessageWrapper id="excludeHostels" defaultMessage="Exclude hostels" />} onClick={onClick} />;
};
const IncludeHostelsMessage = ({
  onClick
}: HostelMessageProps) => {
  return <MessageLayout message={<FormattedMessageWrapper id="resultsHaveNoHostels" defaultMessage="You have excluded hostels from results." />} linkText={<FormattedMessageWrapper id="includeHostels" defaultMessage="Include hostels" />} onClick={onClick} />;
};
const MessageLayout = ({
  message,
  linkText,
  onClick
}: MessageLayoutProps) => {
  return <Grid container alignItems="center" spacing="s200">
      <Grid mobileSm={12} desktopXs="fit">
        {message}
      </Grid>
      <Grid mobileSm={12} desktopXs="fill">
        <ButtonLink isCompact isBold={false} onClick={onClick}>
          {linkText}
        </ButtonLink>
      </Grid>
    </Grid>;
};
export const HostelsAlert = ({
  onChange
}: Props) => {
  const noHostels = useSelector(getNoHostels);
  const {
    isMobile
  } = useDeviceLayout();
  const isSortPriceAscending = useSelector(isSortAscendingByPrice);
  const showHostelsAlert = useSelector(getShowHostelsAlert);
  const [isClosedByUser, setIsClosedByUser] = useState<boolean>(false);
  useEffect(() => {
    if (!isSortPriceAscending) {
      setIsClosedByUser(false);
    }
  }, [isSortPriceAscending]);
  const handleExcludeClick = (event: React.MouseEvent) => {
    event.preventDefault();
    onChange({
      noHostels: '1',
      userSearch: '1'
    });
  };
  const handleIncludeClick = (event: React.MouseEvent) => {
    event.preventDefault();
    onChange({
      noHostels: undefined,
      userSearch: '1'
    });
  };
  const handleCloseClick = () => {
    setIsClosedByUser(true);
  };
  if (showHostelsAlert && !isClosedByUser) {
    return <OpacityAnimation delay={1500} duration={0.5}>
        <HostelsAlertWrapper>
          <Alert alignIcon={isMobile ? 'flex-start' : 'center'} icon={<Icon name="Information" />} onClose={handleCloseClick}>
            {noHostels ? <IncludeHostelsMessage onClick={handleIncludeClick} /> : <ExcludeHostelsMessage onClick={handleExcludeClick} />}
          </Alert>
        </HostelsAlertWrapper>
      </OpacityAnimation>;
  }
  return null;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");